import { configureStore } from '@reduxjs/toolkit';

import reducer, { sliceActions } from './slices';

export const actions = sliceActions;

export default configureStore({ reducer });
